import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const ExplorePage = () => {
    return (
        <Container>
                <Row>
                <Col>
                    <h2 style={{ textAlign: 'center', color: 'purple' }}><strong>Listening</strong></h2>
                    <p><strong>The IELTS Listening test is designed to assess your ability to understand spoken English.</strong></p>
                    <p>It consists of four sections, each with a different type of listening material:</p>
                    <ul>
                    <li><strong>Section 1:</strong> A conversation between two people set in an everyday social context.</li>
                        <li><strong>Section 2:</strong>A monologue set in an everyday social context.</li>
                        <li><strong>Section 3:</strong> A conversation between up to four people set in an educational or training context.</li>
                        <li><strong>Section 4:</strong> A monologue on an academic subject.</li>
                    </ul>
                    <p><strong>Each section is followed by a set of questions that you need to answer. The test is approximately 30 minutes long, and you have 10 minutes at the end of the test to transfer your answers to the answer sheet.</strong></p>
                    <br/><br/>
                    <h2 style={{ textAlign: 'center', color: 'purple' }}><strong>Reading</strong></h2>
                    <p><strong>The IELTS Reading test is designed to assess your reading skills in English.</strong></p>
                    <p>It consists of three sections with increasing difficulty:</p>
                    <ul>
                    <li><strong>Section 1:</strong>Contains two or three short factual texts related to everyday life. Topics may include advertisements, timetables, or notices.</li>
                        <li><strong>Section 2:</strong> Contains two short factual texts focusing on work-related issues. Topics may include job descriptions, company policies, or workplace conditions.</li>
                        <li><strong>Section 3:</strong> Contains one longer, more complex text on a topic of general interest. The text may be descriptive, factual, or discursive.</li>
                    </ul>
                    <p><strong>Each section is followed by a set of questions that you need to answer. The test is 60 minutes long, and you must write your answers on the answer sheet during this time.</strong></p>
                    <br/><br/>
                    <h2 style={{ textAlign: 'center', color: 'purple' }}><strong>Writing</strong></h2>
                    <p><strong>The IELTS Writing test is designed to assess your ability to write in English.</strong></p>
                    <p>It consists of two tasks:</p>
                    <ul>
                    <li><strong>Task 1:</strong> You are presented with a graph, table, chart, or diagram and asked to describe, summarize, or explain the information in your own words. You should write at least 150 words.</li>
                        <li><strong>Task 1:</strong> You are asked to write an essay in response to a point of view, argument, or problem. You should present your opinion, justify your opinion, and provide examples to support your arguments. You should write at least 250 words.</li>
                    </ul>
                    <p><strong>The total test time for both tasks is 60 minutes. You are advised to spend about 20 minutes on Task 1 and about 40 minutes on Task 2.</strong></p>
                    <br/><br/>
                    <h2 style={{ textAlign: 'center', color: 'purple' }}><strong>Speaking</strong></h2>
                    <p><strong>The IELTS Speaking test is designed to assess your spoken English skills.</strong></p>
                    <p>It is a face-to-face interview with a certified examiner and is divided into three parts:</p>
                    <ul>
                    <li><strong>Part 1:</strong> Introduction and interview (4-5 minutes) - The examiner will ask you general questions about yourself, your family, your studies, your work, and your interests.</li>
                        <li><strong>Part 2:</strong>  Long turn (3-4 minutes) - You will be given a task card with a topic and a set of questions. You will have 1 minute to prepare and then you will need to speak for 1-2 minutes on the topic.</li>
                        <li><strong>Part 3:</strong>  Discussion (4-5 minutes) - The examiner will ask you further questions related to the topic in Part 2. These questions are more abstract and require you to discuss more complex ideas.</li>
                    
                    </ul>
                    <p><strong>The total test time for the Speaking test is 11-14 minutes.</strong></p>
                </Col>
            </Row>

            <Row>
                <Col className="text-center">
                    <h2 style={{ color: 'purple' }}>Vocabularies</h2>
                </Col>
            </Row>
            <Row>
                <Col>
                    <ul>
                        <li><strong>Abundant</strong> - plentiful, ample</li>
                        <li>Example: The garden was abundant with flowers.</li>
                        <li><strong>Acquire</strong> - obtain, gain</li>
                        <li>Example: She acquired a new skill through practice.</li>
                        <li><strong>Adapt</strong> - adjust, modify</li>
                        <li>Example: Plants can adapt to different climates.</li>
                        <li><strong>Adequate</strong> - sufficient, satisfactory</li>
                        <li>Example: The food supply was adequate for everyone.</li>
                        <li><strong>Advocate</strong> - support, champion</li>
                        <li>Example: The organization advocates for human rights.</li>
                        <li><strong>Alleviate</strong> - relieve, ease</li>
                        <li>Example: Medicine can alleviate pain.</li>
                        <li><strong>Ambiguous</strong> - unclear, vague</li>
                        <li>Example: His statement was ambiguous and open to interpretation.</li>
                        <li><strong>Analyse</strong> - examine, study</li>
                        <li>Example: Scientists analyze data to draw conclusions.</li>
                        <li><strong>Anticipate</strong> - expect, foresee</li>
                        <li>Example: I anticipate that there will be traffic, so I'm leaving early.</li>
                        <li><strong>Apprehensive</strong> - anxious, worried</li>
                        <li>Example: She was apprehensive about the exam.</li>
                        <li><strong>Arbitrary</strong> - random, chance</li>
                        <li>Example: The selection process seemed arbitrary.</li>
                        <li><strong>Assess</strong> - evaluate, judge</li>
                        <li>Example: Teachers assess students' work.</li>
                        <li><strong>Authenticate</strong> - confirm, verify</li>
                        <li>Example: The signature was authenticated by an expert.</li>
                        <li><strong>Catalyst</strong> - stimulus, impetus</li>
                        <li>Example: The discovery of gold was a catalyst for economic growth.</li>
                        <li><strong>Circumstance</strong> - situation, condition</li>
                        <li>Example: Given the circumstances, I think we should wait.</li>
                        <li><strong>Clarify</strong> - explain, elucidate</li>
                        <li>Example: Can you clarify what you mean?</li>
                        <li><strong>Cohesive</strong> - united, integrated</li>
                        <li>Example: The team was cohesive and worked well together.</li>
                        <li><strong>Comprehensive</strong> - complete, thorough</li>
                        <li>Example: The report provides a comprehensive overview of the issue.</li>
                        <li><strong>Concede</strong> - admit, acknowledge</li>
                        <li>Example: He conceded defeat and congratulated his opponent.</li>
                        <li><strong>Conceive</strong> - imagine, envisage</li>
                        <li>Example: It's hard to conceive of a world without technology.</li>
                        <li><strong>Concise</strong> - brief, succinct</li>
                        <li>Example: His explanation was concise and to the point.</li>
                        <li><strong>Conduct</strong> - behavior, demeanor</li>
                        <li>Example: His conduct during the meeting was exemplary.</li>
                        <li><strong>Constitute</strong> - form, establish</li>
                        <li>Example: These rules constitute the basis of our organization.</li>
                        <li><strong>Contradict</strong> - oppose, deny</li>
                        <li>Example: Her statement contradicts what he said.</li>
                        <li><strong>Correlate</strong> - relate, connect</li>
                        <li>Example: Studies have shown that smoking correlates with lung cancer.</li>
                        <li><strong>Criterion</strong> - standard, measure</li>
                        <li>Example: One criterion for success is determination.</li>
                        <li><strong>Cumulative</strong> - accumulated, increasing</li>
                        <li>Example: The cumulative effect of pollution is concerning.</li>
                        <li><strong>Debate</strong> - argue, discuss</li>
                        <li>Example: The candidates will debate the issues tonight.</li>
                        <li><strong>Decipher</strong> - interpret, decode</li>
                        <li>Example: Can you decipher this code?</li>
                        <li><strong>Deduce</strong> - infer, conclude</li>
                        <li>Example: From the evidence, we can deduce that he is guilty.</li>
                        <li><strong>Deficient</strong> - inadequate, insufficient</li>
                        <li>Example: His diet was deficient in vitamins.</li>
                        <li><strong>Degenerate</strong> - decline, deteriorate</li>
                        <li>Example: The neighborhood has degenerated over the years.</li>
                        <li><strong>Delineate</strong> - outline, describe</li>
                        <li>Example: The report delineates the steps to be taken.</li>
                        <li><strong>Denote</strong> - indicate, signify</li>
                        <li>Example: The color red often denotes danger.</li>
                        <li><strong>Depict</strong> - portray, describe</li>
                        <li>Example: The painting depicts a beautiful landscape.</li>
                        <li><strong>Derive</strong> - obtain, deduce</li>
                        <li>Example: The word "robot" is derived from a Czech word.</li>
                        <li><strong>Deviate</strong> - diverge, depart</li>
                        <li>Example: He deviated from the original plan.</li>
                        <li><strong>Differentiate</strong> - distinguish, separate</li>
                        <li>Example: It's important to differentiate between fact and opinion.</li>
                        <li><strong>Diminish</strong> - reduce, decrease</li>
                        <li>Example: The number of students has diminished over time.</li>
                        <li><strong>Discern</strong> - perceive, recognize</li>
                        <li>Example: She could discern a faint outline in the darkness.</li>
                        <li><strong>Discrepancy</strong> - difference, inconsistency</li>
                        <li>Example: There was a discrepancy between the two reports.</li>
                        <li><strong>Discrete</strong> - separate, distinct</li>
                        <li>Example: The project is divided into discrete phases.</li>
                        <li><strong>Diverse</strong> - varied, different</li>
                        <li>Example: The country is known for its diverse culture.</li>
                        <li><strong>Divulge</strong> - reveal, disclose</li>
                        <li>Example: He refused to divulge the secret.</li>
                        <li><strong>Dominate</strong> - control, rule</li>
                        <li>Example: The team has dominated the competition.</li>
                        <li><strong>Economical</strong> - thrifty, frugal</li>
                        <li>Example: She is economical with her words.</li>
                        <li><strong>Elaborate</strong> - detailed, intricate</li>
                        <li>Example: The plan was elaborate and well thought out.</li>
                        <li><strong>Elicit</strong> - evoke, draw out</li>
                        <li>Example: Her speech elicited a standing ovation.</li>
                        <li><strong>Emphasize</strong> - highlight, underscore</li>
                        <li>Example: It's important to emphasize the key points.</li>
                        <li><strong>Encounter</strong> - experience, face</li>
                        <li>Example: We encountered many difficulties along the way.</li>
                        <li><strong>Endorse</strong> - support, approve</li>
                        <li>Example: The company endorsed the new product.</li>
                        <li><strong>Enhance</strong> - improve, strengthen</li>
                        <li>Example: Exercise can enhance your mood.</li>
                        <li><strong>Enumerate</strong> - list, count</li>
                        <li>Example: She could enumerate the benefits of the plan.</li>
                        <li><strong>Equate</strong> - equal, match</li>
                        <li>Example: Happiness cannot be equated with wealth.</li>
                        <li><strong>Evoke</strong> - provoke, summon</li>
                        <li>Example: The song evoked memories of her childhood.</li>
                        <li><strong>Exacerbate</strong> - worsen, aggravate</li>
                        <li>Example: His comments only served to exacerbate the situation.</li>
                        <li><strong>Exemplify</strong> - illustrate, demonstrate</li>
                        <li>Example: The case exemplifies the need for change.</li>
                        <li><strong>Exhaustive</strong> - thorough, comprehensive</li>
                        <li>Example: He conducted an exhaustive search for the missing keys.</li>
                        <li><strong>Exhibit</strong> - display, show</li>
                        <li>Example: The museum exhibits artifacts from ancient times.</li>
                        <li><strong>Exploit</strong> - utilize, use</li>
                        <li>Example: He was accused of exploiting his workers.</li>
                    </ul>
                </Col>
            </Row>
            <Row>
                <Col className="text-center">
                    <h2 style={{ color: 'purple' }}>Idioms</h2>
                </Col>
            </Row>
            <Row>
                <Col>
                    <ul>
                        <li><strong>A piece of cake</strong> - Something very easy</li>
                        <li><strong>A drop in the bucket</strong> - A very small amount compared to what is needed</li>
                        <li><strong>Actions speak louder than words</strong> - What you do is more important than what you say</li>
                        <li><strong>Bite the bullet</strong> - To endure a painful or difficult situation</li>
                        <li><strong>Break the ice</strong> - To initiate social interaction in a situation</li>
                        <li><strong>Burn the midnight oil</strong> - To work late into the night</li>
                        <li><strong>Cost an arm and a leg</strong> - To be very expensive</li>
                        <li><strong>Cut to the chase</strong> - To get to the point without wasting time</li>
                        <li><strong>Don't cry over spilled milk</strong> - Don't worry about things that have already happened and cannot be changed</li>
                        <li><strong>Fit as a fiddle</strong> - In good physical condition</li>
                        <li><strong>Hit the nail on the head</strong> - To describe exactly what is causing a situation or problem</li>
                        <li><strong>Jump on the bandwagon</strong> - To join a popular trend or activity</li>
                        <li><strong>Keep an eye on</strong> - To watch or monitor closely</li>
                        <li><strong>Let the cat out of the bag</strong> - To reveal a secret</li>
                        <li><strong>Miss the boat</strong> - To miss an opportunity</li>
                        <li><strong>On the ball</strong> - Alert, competent, and efficient</li>
                        <li><strong>Once in a blue moon</strong> - Very rarely</li>
                        <li><strong>Put all your eggs in one basket</strong> - To risk everything on a single venture</li>
                        <li><strong>Rule of thumb</strong> - A general principle regarded as a guide</li>
                        <li><strong>See eye to eye</strong> - To agree on something</li>
                        <li><strong>Sit on the fence</strong> - To remain neutral or undecided</li>
                        <li><strong>Spill the beans</strong> - To reveal a secret</li>
                        <li><strong>Take with a grain of salt</strong> - To not completely believe something</li>
                        <li><strong>Under the weather</strong> - Not feeling well</li>
                        <li><strong>Up in the air</strong> - Uncertain or undecided</li>
                        <li><strong>When pigs fly</strong> - Something that will never happen</li>
                        <br />
                        {/* Add more idioms in the same format */}
                    </ul>
                </Col>
            </Row>
            <Row>
                <Col className="text-center">
                    <h2 style={{ color: 'purple' }}>Phrases</h2>
                </Col>
            </Row>
            <Row>
                <Col>
                    <ul>
                        <li><strong>As a matter of fact</strong> - Actually; in reality</li>
                        <li><strong>By and large</strong> - Generally speaking; on the whole</li>
                        <li><strong>For instance</strong> - For example</li>
                        <li><strong>In a nutshell</strong> - In summary; briefly</li>
                        <li><strong>On the contrary</strong> - In contrast; opposite</li>
                        <li><strong>To a certain extent</strong> - Partly; to some degree</li>
                        <li><strong>In the long run</strong> - Over a long period of time; eventually</li>
                        <li><strong>To sum up</strong> - In conclusion; to summarize</li>
                        <li><strong>In the blink of an eye</strong> - Very quickly; in an instant</li>
                        <li><strong>In the grand scheme of things</strong> - In the context of the overall situation</li>
                        <li><strong>It goes without saying</strong> - It is obvious; it is understood</li>
                        <li><strong>To put it simply</strong> - To explain something in a simple way</li>
                        <li><strong>As far as I'm concerned</strong> - In my opinion; from my perspective</li>
                        <li><strong>In other words</strong> - Stated differently; to rephrase</li>
                        <li><strong>To be honest</strong> - Honestly speaking; truthfully</li>
                        <li><strong>To make matters worse</strong> - To add to the existing problems</li>
                        <li><strong>To the best of my knowledge</strong> - As far as I know; to the extent of my understanding</li>
                        <li><strong>In the nick of time</strong> - Just in time; at the last moment</li>
                        <li><strong>It's a double-edged sword</strong> - Something that has both advantages and disadvantages</li>
                        <li><strong>To turn a blind eye</strong> - To ignore something deliberately</li>
                        <li><strong>It's not my cup of tea</strong> - It's not something I enjoy or am interested in</li>
                        <li><strong>To be on the same page</strong> - To have the same understanding or agreement</li>
                        <li><strong>To get the ball rolling</strong> - To start something; to begin</li>
                        <li><strong>To be a piece of cake</strong> - To be very easy</li>
                        <li><strong>To be on cloud nine</strong> - To be extremely happy or joyful</li>
                        <li><strong>To be in hot water</strong> - To be in trouble or facing difficulties</li>
                        <li><strong>To be over the moon</strong> - To be extremely happy or delighted</li>
                        <li><strong>To be a drop in the ocean</strong> - To be a very small part of something much bigger</li>
                        <li><strong>To be in the same boat</strong> - To be in a similar situation as someone else</li>
                        <li><strong>To be a breath of fresh air</strong> - To be refreshing or different in a positive way</li>
                        <br />
                        {/* Add more phrases in the same format */}
                    </ul>
                </Col>
            </Row>
        </Container>
    );
};

export default ExplorePage;




